export enum MemberType {
    active = 1,
    guest = 2
}
